<!-- Banner -->
<article class="banner">
    <!-- Desktop Banner -->
    <div class="row banner__box hidebelow900">
        <div class="banner__box--info">
            <h3 class="light-color text-capitalize">{{prog?.activation?.title}}</h3>
            <p class="light-color ">{{prog?.description}}</p>
            <div class="banner_box--learning">
                <div class="banner_box--progress mg-b20" *ngIf="program &&  program[0]?.progress <= 100">
                    <label for="progressbar">
                        <span class="opacity-50 light-color" *ngIf="currentCardName">{{(currentCardName == 'COMPLETED')
                            ? '' : 'Currently at'}} {{currentCardName | titlecase}}</span>
                        <span class="orange-color bold-text">{{program[0]?.progress| number:'1.0-0'}}%</span>
                    </label>
                    <progress id="progressbar" value="{{program[0]?.progress}}" max="100"></progress>
                </div>
                <div class="banner_box--progress mg-b20" style="width: 215px; padding: 10px" *ngIf="program && program.length && program[0]?.totalDuration && (program[0]?.totalDuration > 0)">
                    <label for="progressbar">
                        <span class="opacity-50 light-color mg-b0">Total Learning Time </span>
                        <span class="orange-color bold-text mg-b0"><i>{{program[0]?.totalDuration | formateSeconds: 'hourMinute'}}</i></span>
                    </label>
                </div>
                <a class="light-color link-no-underline pd-t10 pd-b10 pd-l20 pd-r20 cursor-pointer text-uppercase mg-b20"
                    *ngIf="bannerBtnTxt && !buttonReport" (click)="goToNextItem(true)">
                    <!-- {{(program && program[0]?.progress === undefined)? 'START':'RESUME'}} LEARNING -->
                    {{ isProgramStarted ? 'RESUME':'START'}} LEARNING
                </a>
                <a class="light-color link-no-underline pd-t10 pd-b10 pd-l20 pd-r20 cursor-pointer text-uppercase mg-b20"
                    *ngIf="!bannerBtnTxt && !buttonReport" (click)="goToNextItem()">
                    Wait for next unlock
                </a>
                <a class="light-color link-no-underline pd-t10 pd-b10 pd-l20 pd-r20 cursor-pointer text-uppercase mg-b20"
                    *ngIf="buttonReport" (click)="goToNextItem()">
                    <ng-container *ngIf="!isProgramCompletionDatePassed">Certificate &</ng-container> Transcript
                </a>
                <!-- <a class="light-color link-no-underline pd-t10 pd-b10 pd-l20 pd-r20 cursor-pointer"
                    *ngIf="program &&  program[0]?.progress < 100"> RESUME
                    LEARNING</a> -->
            </div>
        </div>
        <div class="banner__box--right text-center" (click)="openModal()">
            <div
                class="popup__show banner__box--playbutton justify-content-center d-flex align-items-center mg-auto yellow-bg position-relative ripple">
                <span class="icon-play-button font-20 light-color"></span>
            </div>
            <p class="banner__box--text light-color mg-t10">Watch Program Introduction</p>
        </div>
    </div>
    <!-- Popup -->
    <!-- <div class="popup-main popup--overlay">
    <div class="popup">
    <button class="popup--close" href=""><span class="icon-cross"></span></button>

        <div class="popup__content">
            <h2>Program Block Introductory Video 1</h2>
        <p>It is a long established fact that a reader will be distracted by the readable
            content of a page when looking at its layout.</p>
            <img src="assets/images/video.PNG" alt="" />
            <button class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20">
                START COURSE
            </button>
        </div>
    </div>
</div> -->
    <!-- Desktop Banner -->
    <!-- Mobile Banner -->
    <div class="row banner__box hideabove900">
        <div class="banner__box--info">
            <h3 class="light-color text-capitalize">{{prog?.activation?.title}}</h3>
            <p class="light-color banner_text--desc">{{prog?.description}}</p>
            <!-- Display this when course has started -->
            <div class="banner_box--progress mg-b20" *ngIf="program &&  program[0]?.progress <= 100">
                <label for="progressbar">
                    <span class="opacity-50 light-color" *ngIf="currentCardName">{{(currentCardName == 'COMPLETED')
                        ? '' : 'Currently at'}} {{currentCardName | titlecase}}</span>
                    <span class="orange-color bold-text">{{program[0]?.progress |number:'1.0-0'}}%</span>
                </label>
                <progress id="progressbar" value="{{program[0]?.progress}}" max="100"></progress>
            </div>
            <div class="banner_box--progress mg-b20" style="padding: 10px" *ngIf="program && program.length && program[0]?.totalDuration && (program[0]?.totalDuration > 0)">
                <label for="progressbar">
                    <span class="opacity-50 light-color mg-b0">Total Learning Time </span>
                    <span class="orange-color bold-text mg-b0"><i>{{program[0]?.totalDuration | formateSeconds: 'hourMinute'}}</i></span>
                </label>
            </div>
            <!-- Display this when course has started -->
        </div>
        <div class="banner__box--right d-flex justify-content-between align-items-center">
            <!-- Change the Button Text into Resume Learning when course has started -->
            <a class="light-color link-no-underline pd-t10 pd-b10 pd-l20 pd-r20 cursor-pointer text-uppercase mg-b20"
                *ngIf="bannerBtnTxt && !buttonReport" (click)="goToNextItem(true)">
                <!-- {{(program && program[0]?.progress === undefined)? 'START':'RESUME'}} LEARNING </a>-->
                {{ isProgramStarted ? 'RESUME':'START'}} LEARNING
            </a>
            <a class="light-color link-no-underline pd-t10 pd-b10 pd-l20 pd-r20 cursor-pointer text-uppercase mg-b20"
                *ngIf="!bannerBtnTxt && !buttonReport" (click)="goToNextItem()">
                Wait for next unlock</a>
            <a class="light-color link-no-underline pd-t10 pd-b10 pd-l20 pd-r20 cursor-pointer text-uppercase mg-b20"
                *ngIf="buttonReport" (click)="goToNextItem()">
                <ng-container *ngIf="!isProgramCompletionDatePassed">Certificate &</ng-container> Transcript</a>

            <!-- Change the Button Text into Resume Learning when course has started -->
            <div (click)="openModal()" id="popup__show--mob" class="d-flex justify-content-between align-items-center">
                <!-- <p class="banner__box--text light-color mg-r10">Watch Program Introduction</p> -->
                <div
                    class=" banner__box--playbutton justify-content-center d-flex align-items-center mg-auto yellow-bg ripple">
                    <span class="icon-play-button font-10 light-color"></span>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile Banner -->
</article>
<!-- Banner -->


<app-static-player *ngIf="showBannerMobal" (modelOpen)="closeModel($event)" [type]="'PROGRAM'"
    [file]="prog?.introduction.videoUrl" [autoStart]="true" [isInPopup]="false"
    [thumb]="prog?.introduction.videoThumbnailUrl" [videoTitle]="prog?.introduction?.videoThumbnailUrl"
    [videoDesc]="prog?.introduction?.description" [programIntroVideo]="true"></app-static-player>
<app-static-player *ngIf="showProgramEndVideo" (modelOpen)="closeModelEndVideo($event)" [type]="'PROGRAM'"
    [file]="prog?.onCompletion?.videoUrl" [autoStart]="true" [isInPopup]="false"
    [thumb]="prog?.onCompletion?.videoThumbnailUrl" [videoTitle]="prog?.onCompletion?.videoThumbnailUrl"
    [videoDesc]="prog?.onCompletion?.description" [programEndVideo]="true"></app-static-player>

<app-common-feedback (hideFeedback)="hideFeedback($event)" *ngIf="showFeedback" [user]="user"
    [completedItemObj]="completedItemObj" [programActivationId]="activationInfo.programActivationId">
</app-common-feedback>

<app-masterclass-threshold-modal [user]="user" (hideModal)="hideMasterClassThreshold($event)"
    *ngIf="showMasterClassThreshold"></app-masterclass-threshold-modal>
